import React, {useCallback, useEffect, useState} from 'react'
import VerificationInput from "react-verification-input";
import {VertAlert, VertButton, VertModal, VertTypography} from "@vertem-core/vertice-ds";
import Timer from "./Timer";
import {use2FAContext} from "./Provider";
import {useCheckoutProvider} from "components/Checkout/CheckoutProvider";
import {useMediaQuery} from "react-responsive";
import ynToBool from 'Utils/ynToBool';

const CheckoutModal = () => {
    const [ timesOut, setTimes ] = useState(false)
    const { showModal, handleCloseModal, sendSMS, resendSMS, tryCounter, changeState, GotoConfirmation, GoToCart  } = use2FAContext()
    const { handleAddErrors, clearCredicard, handleRemoveErrors } = useCheckoutProvider()
    const [ token, setToken ] = useState('')
    const [ loading, setLoading ] = useState(false)
    const [ error, setError ] = useState(null)
    const [ success, setSuccess ] = useState(false)
    const [ stopTimeOut, setStopTimeOut ] = useState(false)
    const isMobile = useMediaQuery({
        maxWidth: 600
    })

    const handleToken = useCallback((newToken) => {
        setToken(newToken)
    }, [ token ])

    const handleSetError = useCallback(({ response: e }) => {
        const message = e?.data?.errors || []

        const error = {}
        error['message'] = (message[0] && (message[0].message)) || e.data?.message  || e?.data || ''
        error['subMessage'] = (message[0] && (message[0].subMessage)) || ''
        error['title'] = (e.data.status && e.data.status === 'TokenFinished') ? 'Não foi possível concluir o seu pagamento': ''
        setError(error)
    }, [ error ])

    const onCancel = () => {
        handleAddErrors('checkout_2fa', {
            'title': 'Não foi possível concluir o seu pagamento.',
            'message': ''
        });
        handleCloseModal()
        GoToCart(2)
        setError(null)
        changeState("tryCounter", 1)
    }

    const HandleSendSMS = useCallback(() => {
        setLoading(true)
        if (tryCounter > 3) return;
        changeState("tryCounter", tryCounter + 1)
        sendSMS(token).then(({ data, status }) => {
            const _status = data.status;
            const success = (!(status === 202 && _status === 'RequiresTokenValidation'))

            const statusCode = status
            const errorToken =
            statusCode === 202 && _status === 'RequiresTokenValidation'

            if (success) {
                setError(null)
                clearCredicard()
                handleRemoveErrors('checkout_2fa')
            }
            if (errorToken) setError({
                message: 'Token inválido',
                subMessage: ''
            })

            if (!success && tryCounter + 1 > 3) {
                setError(null)
                handleAddErrors('checkout_2fa', {
                    'title': 'Parece que você atingiu o limite de tentativas.',
                    'message': 'Não se preocupe, respire fundo e tente novamente mais tarde.😊'
                });
                handleCloseModal()
                GoToCart()
                return;
            }
            setSuccess(success)
        }).catch((e) => {
           
            if (tryCounter + 1 > 3) {
                setError(null)
                handleAddErrors('checkout_2fa', {
                    'title': 'Parece que você atingiu o limite de tentativas.',
                    'message': 'Não se preocupe, respire fundo e tente novamente mais tarde.😊'
                });
                handleCloseModal()
                setTimeout(() => {
                    GoToCart();
                }, 2000)
                return;
            }
            handleSetError(e)
        }).finally(() => {
            setLoading(false)
        })
    }, [ sendSMS, token, loading, changeState, error, tryCounter, GoToCart ])

    const HandleResendSMS =  useCallback(() => {
        setLoading(true)
        resendSMS(token).then(() => {
            setTimes(false)
        }).catch((e) => {
            setStopTimeOut(true)
            handleSetError(e)
        }).finally(() => {
            setLoading(false)
            changeState("tryCounter", tryCounter + 1)
        })
    }, [ resendSMS, loading, tryCounter, token ])

    const HandleResendCall =  useCallback(() => {
        setLoading(true)
        resendSMS(token, 2).then(() => {
            setTimes(false)
        }).catch((e) => {
            setStopTimeOut(true)
            handleSetError(e)
        }).finally(() => {
            setLoading(false)
            changeState("tryCounter", tryCounter + 1)
        })
    }, [ resendSMS, loading, tryCounter, token ])

    const HandleResendWhatsapp =  useCallback(() => {
        setLoading(true)
        resendSMS(token, 3).then(() => {
            setTimes(false)
        }).catch((e) => {
            setStopTimeOut(true)
            handleSetError(e)
        }).finally(() => {
            setLoading(false)
            changeState("tryCounter", tryCounter + 1)
        })
    }, [ resendSMS, loading, tryCounter, token ])

    useEffect(() => {
        if (success) {
            GotoConfirmation()
        }
    }, [success, GotoConfirmation]);

    useEffect(() => {
        if (showModal) {
            setToken('')
            handleRemoveErrors('checkout_2fa')
        }
    }, [ showModal ])
    
    return (
        <>
            <VertModal
                title={`Valide seu Token - Tentativa ${ (tryCounter > 3) ? (3 - 1): tryCounter } de 3`}
                open={showModal}
                footer={null}
                width={600}
                onCancel={() => onCancel()}
            >
                <section className={`vert-two-factor-content padding-y-small ${ (isMobile) ? '' : 'padding-x-small' }`}>
                    {(() => {
                        if (error) return (
                            <>
                                <div className='padding-bottom-small'>
                                    <VertAlert type='error' message={error.title || error.message } description={(error.title) ? error.message: error.subMessage} />
                                </div>
                            </>
                        )

                        return null
                    })()}
                    {(() => {
                        if (success) return (
                            <>
                                <div className='padding-bottom-small'>
                                    <VertAlert type='success' message={'Código confirmado!'} />
                                </div>
                            </>
                        )

                        return null
                    })()}
                    <header className='padding-bottom-small'>
                        <VertTypography.Title level={3} className="margin-y-none padding-bottom-small">
                            Verifique seu celular
                        </VertTypography.Title>
                        <VertTypography.Paragraph
                            className="font-w-400 margin-y-none"
                            strong={false}
                        >
                            Vamos te ajudar a verificar sua conta. Para isso, você vai precisar de um código que te
                            enviaremos no celular!
                        </VertTypography.Paragraph>
                    </header>
                    <section>
                        <VertTypography.Paragraph
                            className="font-w-400 margin-y-none padding-bottom-small"
                            strong={false}
                        >
                            Digite o código recebido por celular:
                        </VertTypography.Paragraph>
                        <div className='padding-top-small'>
                            <VerificationInput
                                validChars="0-9"
                                classNames={{
                                    container: 'vert-input-token-container',
                                    character: 'vert-input-character-token justify-center align-center',
                                    characterSelected: 'vert-input-character-token-selected',
                                    characterFilled: 'vert-input-character-token-filled',
                                    characterInactive: 'vert-input-character-token-inactive',
                                }}
                                value={token}
                                onChange={(e) => {
                                    handleToken(e)
                                }}
                            />
                        </div>
                        {(() => {
                            if (!timesOut) return (<>
                                <div className="padding-top-regular padding-bottom-small">
                                    <VertButton
                                        type='highlight'
                                        className='vert-two-fa-trigger'
                                        size="large"
                                        disabled={!token || token.length < 6 || stopTimeOut}
                                        loading={loading}
                                        onClick={() => {
                                            HandleSendSMS()
                                        }}
                                    >
                                        Enviar
                                    </VertButton>
                                </div>
                                <div className="padding-bottom-small">
                                    <VertButton
                                        type='default'
                                        className='vert-two-fa-trigger padding-x-small'
                                        size="large"
                                        disabled
                                    >
                                        O código expira em {(() => {
                                            if (showModal) return (<>
                                                <Timer stop={stopTimeOut} start={showModal} callback={() => {
                                                    setTimes(true)
                                                    handleToken('')
                                                }} timeEnd={( 2 * (60 * 1000))} />
                                            </>)
                                        return '02:00'
                                    })()}
                                    </VertButton>
                                </div>
                            </>)

                            return (<>
                                <div className="padding-top-regular padding-bottom-small">
                                    <VertButton
                                        type='highlight'
                                        className='vert-two-fa-trigger'
                                        size="large"
                                        onClick={() => {
                                            HandleResendSMS()
                                        }}
                                        loading={loading}
                                    >
                                        Reenviar o SMS
                                    </VertButton>
                                </div>
                                <div className="padding-bottom-small">
                                    <VertButton
                                        type='default'
                                        className='vert-two-fa-trigger'
                                        size="large"
                                        loading={loading}
                                        onClick={() => {
                                            HandleResendCall()
                                        }}
                                    >
                                        Receber ligação
                                    </VertButton>
                                </div>
                                {ynToBool(process.env.REACT_APP_HAS_WHATSAPP_2FA_TOKEN) && (
                                    <div className="padding-bottom-regular">
                                        <VertButton
                                            type='default'
                                            className='vert-two-fa-trigger'
                                            size="large"
                                            loading={loading}
                                            onClick={() => {
                                                HandleResendWhatsapp()
                                            }}
                                        >
                                            Receber pelo WhatsApp
                                        </VertButton>
                                    </div>
                                )}
                            </>)
                        })()}
                    </section>
                </section>
            </VertModal>
        </>
    )
}


export default CheckoutModal
